function useScrollTo() {
  const scrollTo = ({ target, behavior = "smooth", top }) => {
    if (!target) return

    setTimeout(() => {
      window.scrollTo({
        behavior,
        top: top
          ? top
          : target.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            70,
      })
    }, 0)
  }

  return { scrollTo }
}

export default useScrollTo
